//      
import React from 'react';

import { Button } from 'bs';
import Icon from 'components/Icon';

              
                   
                  
                                                     
                        
  

const SubmitButton = ({
    label,
    icon,
    submitting,
    disabled,
    iconPositionToLabel,
    ...domProps
}       ) => (
    <Button
        type='submit'
        flavor='primary'
        disabled={disabled || submitting}
        {...domProps}
    >
        {iconPositionToLabel === 'right' && label + ' '}
        <Icon name={submitting ? 'circle-notch' : icon} spin={submitting} />
        {iconPositionToLabel === 'left' && ' ' + label}
    </Button>
);

SubmitButton.defaultProps = {
    icon: 'plus',
    label: 'Submit',
    iconPositionToLabel: 'left',
    submitting: false,
};

export default SubmitButton;
